export const AUTH_USER = 'AUTH_USER';
export const SEND_PHONE_NUMBER = 'SEND_PHONE_NUMBER';
export const REGISTER_USER = 'REGISTER_USER';
export const VERIFYING_NUMBER = 'VERIFYING_NUMBER';